import axios from 'axios'
import { errMsg } from '../utils/business'
const errorResponseStatusMap = {
    401: '未授权，请重新登录',
    403: '会话失效，请重新登陆!',
    404: '错误请求',
    406: '错误请求，参数有误',
    499: '服务未找到！',
    500: '服务器异常',
    513: '内部请求服务错误',
    550: '系统错误，请稍后重试',
    555: '业务请求异常',
}

const axiosInstance = axios.create({
    timeout: 60 * 1000,
    params: {
        time: null
    }
})

// 请求拦截
axiosInstance.interceptors.request.use(config => {
    config.params.time = new Date().getTime()
    config.headers = {
        'Content-Type': 'application/json',
    }
    return config
}, function (error) {
    return Promise.reject(error)
})

// 拦截响应
axiosInstance.interceptors.response.use(
    response => {
        return response.data
    },
    async (error) => {
    if (error?.response) {
        const status = error.response.status
        if (errorResponseStatusMap[status]) {
            errMsg(errorResponseStatusMap[status])
        } else if (error.response?.data?.msg) {
            errMsg(error.response?.data?.msg || `连接错误：${error.response?.status}`)
        }
    } else {
        errMsg('网络出现问题，请稍后再试！')
    }
    return Promise.reject(error)
})

export function details (data, dataa) {
    return axiosInstance({
        url: '/api/api/user/details',
        method: 'GET',
        params: {
            code: data,
            type: dataa
        }
    })
}

// 获取code
export function getWxCode (data) {
    return axiosInstance({
        url: '/api/mckinsey-sso/aad-wx-login/callback',
        method: 'GET',
        params: {
            ...data
        },
    })
}
